<template>
  <nav class="toolbar">
    <InputSearch
      class="search"
      :focus="shouldFocusSearch"
      :placeholder="searchPlaceholder"
      :value="searchTerm"
      @input="triggerSearch"
    />
    <IconButton
      v-if="$hasFeatureFlag($featureFlags.pwmSharedFoldersSettings)"
      hasNoBackground
      icon="settings"
      iconPosition="left"
      text="Shared Folder Settings"
      :to="$options.passwordManagerRoutes.sharedFoldersSettings"
      type="secondary"
    />
  </nav>
</template>

<script>
import {
  IconButton,
  InputSearch,
} from '@jumpcloud/ui-components';
import { passwordManagerRoutes } from 'client/PasswordManager/PasswordManagerConstants';

export default {
  name: 'SharedFoldersItemListToolbar',

  components: {
    IconButton,
    InputSearch,
  },

  passwordManagerRoutes,

  props: {
    searchPlaceholder: {
      type: String,
      default: 'Search',
    },

    searchTerm: {
      type: String,
      default: '',
    },

    shouldFocusSearch: Boolean,
  },

  methods: {
    triggerSearch(value) {
      this.$emit('triggerSearch', value);
    },
  },
};
</script>

<style scoped>
  .toolbar {
    display: flex;
    justify-content: space-between;
    padding: var(--jc-spacer)  var(--jc-spacer) var(--jc-spacer-x-small) 0;
  }

  .search {
    flex: 0 1 35ch;
  }
</style>
